export interface UseCaseTranslation {
  language: string;
  title: string;
  description?: string;
  name?: string;
}

export function buildUseCaseTranslations(
  titleDe: string,
  descriptionDe: string,
  titleEn?: string,
  descriptionEn?: string,
): UseCaseTranslation[] {
  return [
    {
      language: 'de',
      title: titleDe,
      description: descriptionDe,
      name: titleDe,
    },
    {
      language: 'en',
      title: titleEn || titleDe,
      description: descriptionEn || descriptionDe,
      name: titleEn || titleDe,
    },
  ];
}
